import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import * as moment from "moment";
import { SignalRConnection } from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class CurrentStateService extends BaseService {

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastCurrentState").subscribe(
      (result: any) => {
        console.log("broadcastCurrentState", result);

        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
          result = _.sortBy(result, 'LOCATION_CLASS');
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;

          let Report_Periods = [];
          let ON_HAND_QUANTITY = [];
          let ALLOCATED_QUANTITY = [];

          for (let i = 0; i < result.length; i++) {
            Report_Periods.push(result[i].LOCATION_CLASS);
            ON_HAND_QUANTITY.push(result[i].ON_HAND_QUANTITY);
            ALLOCATED_QUANTITY.push(result[i].ALLOCATED_QUANTITY);
          }

          this.addDataSeries(widget.chartOptions, ON_HAND_QUANTITY, 'On Hand Quantity', 'bar');
          this.addDataSeries(widget.chartOptions, ALLOCATED_QUANTITY, 'Allocated Quantity', 'bar');
          widget.chartOptions.yAxis[0].axisLabel.rotate = 30;
          widget.chartOptions.xAxis.data = Report_Periods;

          if (widget.IfNoDataFound) {
            widget.errorMessage = errorMessages.noWidgetData;
          }
          else {
            widget.errorMessage = null;
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
      },
      err => {
        console.log("listenFor broadcastCurrentState error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/current-state.service.ts